﻿import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AgmMap } from '@agm/core';

@Component({
    selector: 'app-find-a-dealer',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.less'],
    encapsulation: ViewEncapsulation.None,
})

export class AppComponent implements OnInit {

    @ViewChild('mapDealer') mapDealer: AgmMap;
    @ViewChild('mapMaintenance') mapMaintenance: AgmMap;

    contactForm: FormGroup;
    dealerSearchForm: FormGroup;
    dealerMaintenanceForm: FormGroup;
    dealers: any = [];
    cf_submitted: Boolean = false;
    df_submitted: Boolean = false;
    mf_submitted: Boolean = false;
    cf_flash: any = {};
    df_flash: any = {};
    mf_flash: any = {};
    showMap_dealer: Boolean = false;
    showMap_maintenance: Boolean = false;
    typeaheadSettings: any = {};
    selectedLocation: any = {};
    tempLocation: any = {};
    selectedDealer: any = null;
    builder: any = null;
    no_people: any = [
        {'id': 1, 'name': 1},
        {'id': 2, 'name': 2},
        {'id': 3, 'name': 3},
        {'id': 4, 'name': 4},
        {'id': 5, 'name': 5},
    ];
    default_lng = 151.20929550000005;
    default_lat = -33.8688197;
    user_location = null;
    constructor(
        private formBuilder: FormBuilder,
        private http: HttpClient) {}

    ngOnInit() {

        this.selectedLocation = {
            'lat': this.default_lat,
            'lng': this.default_lng
        };

        this.dealerSearchForm = this.formBuilder.group({
            dealer_type: ['', Validators.required],
            dealer_service: [''],
            location: ['', Validators.required]
        });

        this.dealerMaintenanceForm = this.formBuilder.group({
            dealer_maintenance: [''],
            location: ['', Validators.required]
        });


        this.typeaheadSettings = {
            'showCurrentLocation': false,
            'showRecentSearch': false,
            'showSearchButton': false,
            'inputPlaceholderText': 'Or, enter your suburb',
            'geoCountryRestriction': ['AU','NZ'],
            'geoTypes': ['(cities)','(regions)']
        }

        this.contactForm = this.formBuilder.group({
            builder_id: [''],
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact_number: [''],
            location: ['', Validators.required],
            no_adults: [0],
            no_children: [0],
            pool_style: ['', Validators.required],
            special_requirements: [''],
            comments: ['']
        });

        // load dealer if passed in
        if ((<any>window).builder_id !== undefined && (<any>window).builder_id != 0) {
            this.http.get('/api/dealer/' + (<any>window).builder_id).subscribe(response => {
                this.builder = response;
                if (this.builder.id) {
                    this.contactForm.controls['builder_id'].setValue(this.builder.id);
                }
            }, error => {
                this.builder = null;
            });
        }
        this.dealerSearchForm.controls['location'].setValue(this.selectedLocation);
        this.dealerMaintenanceForm.controls['location'].setValue(this.selectedLocation);
    }

    ngAfterViewInit() {
        this.userLocation();
        this.searchDealer();
    }


    userLocation() {
        // if (this.user_location) {
        //     this.selectedLocation = this.user_location;
        //     this.dealerSearchForm.controls['location'].setValue(this.selectedLocation);
        //     this.dealerMaintenanceForm.controls['location'].setValue(this.selectedLocation);
        // } else {
            if (this.supportsUserLocation()) {
                // check if geolocation is supported/enabled on current browser

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                    // for when getting location is a success
                        this.user_location = {
                            'lat': position.coords.latitude,
                            'lng': position.coords.longitude
                        };
                        this.selectedLocation.lat = 0;
                        this.selectedLocation.lng = 0;
                        setTimeout(()=>{
                        this.selectedLocation = this.user_location;
                        });
                        this.dealerSearchForm.controls['location'].setValue(this.selectedLocation);
                        this.dealerMaintenanceForm.controls['location'].setValue(this.selectedLocation);
                    }
                );
            }
       // }
    }

    showDealerLocation() {
        return !this.dealerSearchForm.controls['dealer_type'].invalid;
    }
    showMaintenanceLocation() {
        return true;
    }

    supportsUserLocation() {
        return "geolocation" in navigator;
    }

    get cf() {
        return this.contactForm.controls;
    }
    get df() {
        return this.dealerSearchForm.controls;
    }
    get mf() {
        return this.dealerMaintenanceForm.controls;
    }
    saveDealerContactRequest() {
        this.cf_submitted = true;
        if (this.contactForm.invalid) {
            return;
        }

        this.http.post('/api/builder-contact-request', this.contactForm.value).subscribe(response => {
            this.cf_flash.success = 'Request successfully submitted';
        }, error => {
            this.cf_flash.error = 'Error processing request, please try again';
        }, () => {
            this.contactForm.reset();
            this.cf_submitted = false;
            this.builder = null;
            setTimeout(() => {
                this.cf_flash = {};
            }, 2000);
        });
    }
    searchDealer() {
        this.df_submitted = true;

        this.http.post('/api/dealer-search', this.dealerSearchForm.value).subscribe(response => {
            this.dealers = response;
            this.showMap_dealer = true;
            if (this.dealers.length == 0) {
                this.df_flash.success = 'No dealers found matching the search criteria';
            } else {
                this.df_flash = {};
            }
        }, error => {
            this.df_flash.error = 'Error processing request, please try again';
        }, () => {
            this.df_submitted = false;
            this.selectedDealer = null;
            this.contactForm.reset();
        });
    }

    searchMaintenance() {
        this.mf_submitted = true;

        this.http.post('/api/dealer-maintenance-search', this.dealerMaintenanceForm.value).subscribe(response => {
            this.dealers = response;
            this.showMap_maintenance = true;
            if (this.dealers.length == 0) {
                this.mf_flash.success = 'No dealers found matching the search criteria';
            } else {
                this.mf_flash = {};
            }
        }, error => {
            this.mf_flash.error = 'Error processing request, please try again';
        }, () => {
            this.mf_submitted = false;
            this.selectedDealer = null;
            this.contactForm.reset();
        });
    }

    idleDealer() {
        console.log()
        this.dealerSearchForm.controls['location'].setValue({lat: this.mapDealer.latitude, lng: this.mapDealer.longitude});
        this.searchDealer();
    }
    idleMaintenance() {
        this.dealerMaintenanceForm.controls['location'].setValue({lat: this.mapMaintenance.latitude, lng: this.mapMaintenance.longitude});
        this.searchMaintenance();
    }

    // used as callback function for dealer search location typeahead
    dealerLocationCallback(event) {
        if (event.data) {
            this.dealerSearchForm.controls['location'].setValue(event.data.geometry.location);
            this.selectedLocation = event.data.geometry.location;
            this.searchDealer();
        } else {
            this.selectedLocation = {};
        }
    }

    dealerLocationMaintenanceCallback(event) {
        if (event.data) {
            this.dealerMaintenanceForm.controls['location'].setValue(event.data.geometry.location);
            this.selectedLocation = event.data.geometry.location;
            this.searchMaintenance()
        } else {
            this.selectedLocation = {};
        }
    }

    // used as callback function for builder contact request location typeahead
    userLocationCallback(event) {
        console.log(event.data);
        if (event.data) {
            this.contactForm.controls['location'].setValue(event.data.formatted_address);
        }
    }
    selectPin(location) {
        this.dealers = this.dealers.map(item => {
            item.selected = false;
            return item;
        });
        location.selected = true;
    }
    viewDealer(dealer) {
        this.showMap_dealer = false;
        this.showMap_maintenance = false;
        this.selectedDealer = dealer;

        this.http.post('/api/dealer-click-count', {'id': dealer.id})
                .subscribe(response => {},
                        error => {this.df_flash.error = 'Error processing request, please try again';}
                );
    }
    hideDealer() {
        if(this.selectedDealer.source)
        this.showMap_maintenance = true;
        else
        this.showMap_dealer = true;
        this.selectedDealer = null;
    }
    getIcon(dealer) {
        return '/cdn/images/map/pin.png';
    }
}
